export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-6g-ca2a9e161562fa9df01d2a27cd442b7f.webp";